<template>
<div class="row full-width full-height"
  oncontextmenu="return false"
  @dragenter="listen__x__ondragenter"
  @dragleave="listen__x__ondragleave"
  @dragover="listen__x__ondragover"
  @drop="listen__x__ondrop"
  >

  <div class="full-height">
    <sample-image-list
      :images="sampleImages"
      :imageWidth="100"
      @jobstart="showLayer"
      @joberror="(param) => listen__x__onfileerror(param)"
      @jobdone="(file) => preprocessingFile(file)"
    />
  </div>

  <div class="column col full-width full-height" style="padding:10px 30px 25px 30px;">
    <div style="flex:0 0 40px">
      <div class="row" style="padding-bottom: 6px;">
        <div class="row text-h6">
          {{title}}
          <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" />
        </div>
        <q-space />
        <div class="row text-caption" style="align-items:center">
          <health-check-widget
            ref="health-check"
            :functionCheck="healthCheckFunction"
          />
        </div>
      </div>
    </div>

    <div class="full-width" style="flex:0 0 32px;max-height:32px;">
      <q-btn-group dense spread>
        <q-btn dense rounded label="인식언어 :" style="background:rgb(0, 0, 0);color:white;flex:0 0 140px" :disable="true" />
        <q-separator vertical />
        <q-btn dense rounded :icon="state.language == 'English' ? 'done' : 'none'" label="English" style="color:white;" :style="{ background: state.language == 'English' ? 'rgb(2, 123, 227)' : 'rgb(73, 158, 231)' }" @click="state.language='English'" />
        <q-separator vertical />
        <q-btn dense rounded :icon="state.language == 'Chinese' ? 'done' : 'none'" label="Chinese" style="color:white;" :style="{ background: state.language == 'Chinese' ? 'rgb(2, 123, 227)' : 'rgb(73, 158, 231)' }" @click="state.language='Chinese'" />
        <q-separator vertical />
        <q-btn dense rounded :icon="state.language == 'Japanese' ? 'done' : 'none'" label="Japanese" style="color:white;" :style="{ background: state.language == 'Japanese' ? 'rgb(2, 123, 227)' : 'rgb(73, 158, 231)' }" @click="state.language='Japanese'" />
        <q-separator vertical />
        <q-btn dense rounded :icon="state.language == 'Korean' ? 'done' : 'none'" label="Korean" style="color:white;" :style="{ background: state.language == 'Korean' ? 'rgb(2, 123, 227)' : 'rgb(73, 158, 231)' }" @click="state.language='Korean'" />
      </q-btn-group>
    </div>

    <div style="flex:0 0 15px;" />

    <div style="flex:0 0 15px;" />

    <div class="column col bg-white shadow-1 full-width">
      <div class="bg-primary" style="padding:10px 10px;">
        <q-file dark color="white" ref="file" label="파일 업로드..." v-model="compositionFileData.files" dense accept="image/*,.pdf" @input="preprocessingFile">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>
      <q-separator />
      <q-toolbar>
        <q-btn-group class="image-tool-btn-group"  unelevated dense>
          <q-btn unelevated color="primary" icon="fit_screen" label="창에 맞춤" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-view1'].fitToWindow()" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="compare" label="이미지 수정" :disable="frameData1._empty == true" dense no-caps @click="$refs['image-processing-dialog'].open(frameData0)" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="settings" label="옵션" dense no-caps @click="state.dialogOptions.show = true" style="padding:0px 5px;" />
          <q-separator vertical />
          <q-btn unelevated color="primary" icon="file_download" label="인식결과 다운로드" :disable="frameData1._empty == true" dense no-caps @click="listen__result__download" style="padding:0px 5px;" />
        </q-btn-group>
        <q-space />
        <q-tabs
          v-model="state.tab"
          indicator-color="primary"
          inline-label
          shrink stretch
        >
          <q-tab name="image" icon="image" label="Image" />
          <q-tab name="text" icon="list_alt" label="Text">
          </q-tab>
          <q-tab name="json" icon="account_tree" label="Json" />
        </q-tabs>
      </q-toolbar>
      <q-separator />
      <div class="row col full-height full-width">
        <div class="row col full-height full-width">
          <image-view
            ref="image-view1"
            :frame-data="frameData1"
            :pred="pred"
            class="col full-height full-width"
            :passive="false"
            :initial-tool-option="state.currentFrameToolOption"
            :messages-upload="['\'샘플 이미지\'를 선택,', '\'파일 업로드...\'를 클릭,', '또는 이미지를 여기로 \'드래그\' 하여', '인식을 시작합니다.']"
            @onstatechange="listen__image_view__onstatechange" />
        </div>

        <div class="row col full-height full-width" style="border-left:1px solid rgb(210, 210, 210);overflow:auto;">
          <q-tab-panels class="row col full-height full-width" v-model="state.tab" animated>
            <q-tab-panel name="image" class="full-height full-width" style="padding:0;">
              <image-view
                ref="image-view2"
                :frame-data="frameData2"
                :pred="pred"
                class="col full-height full-width"
                :passive="true"
                :initialFrameState="state.currentFrameState"
                :initial-tool-option="state.currentFrameToolOption" />
            </q-tab-panel>
            <q-tab-panel name="text">
              <q-input label="검색..." dense v-model="state.searchText" debounce="300">
                <template v-slot:prepend>
                  <q-icon name="search"/>
                </template>
                <template v-slot:append>
                  <q-icon name="close" @click="state.searchText = ''" class="cursor-pointer" />
                </template>
              </q-input>
              <div style="height:15px;" />
              <transition-group
                name="staggered-fade"
                tag="div"
                class="text-area"
                style="flex:1 0 0;"
                v-bind:css="true"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:leave="leave"
              >
                <BadgeText v-for="text in searchTexts" :data="text" :key="text.id" @ontoggle="listen__badge__ontoggle" />
              </transition-group>
            </q-tab-panel>
            <q-tab-panel name="json">
              <json-viewer :value="jsonData" :expand-depth=3 copyable></json-viewer>
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>
    </div>
  </div>

  <q-dialog v-model="state.dialogOptions.show">
    <q-card style="width: 300px" class="q-px-sm q-pb-md">
      <q-card-section>
        <div class="text-h6">옵션</div>
      </q-card-section>

      <q-item-label header>문자영역 선 색</q-item-label>
      <q-item class="row" dense>
        <div class="row col" style="align-items:center;">
          <div :style="{background: state.currentFrameToolOption.lineColor}" style="width:16px;height:16px;border:1px solid black" />
          <span style="margin-left:10px;">{{ state.currentFrameToolOption.lineColor }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-btn-dropdown
            color="primary"
            unelevated
            no-caps
            dense
            label="변경"
            style="padding:0px 10px;"
          >
            <q-color :model-value="state.currentFrameToolOption.lineColor" @change="val => {state.currentFrameToolOption.lineColor = val}" :default-value="state.currentFrameToolOption.lineColor"  class="my-picker" />
          </q-btn-dropdown>
        </div>
      </q-item>
      <div style="height:10px;" />
      <q-item-label header><b>선택된</b> 문자영역 선 색</q-item-label>
      <q-item class="row" dense>
        <div class="row col" style="align-items:center;">
          <div :style="{background: state.currentFrameToolOption.lineHighlightColor}" style="width:16px;height:16px;border:1px solid black" />
          <span style="margin-left:10px;">{{ state.currentFrameToolOption.lineHighlightColor }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-btn-dropdown
            color="primary"
            unelevated
            no-caps
            dense
            label="변경"
            style="padding:0px 10px;"
          >
            <q-color :model-value="state.currentFrameToolOption.lineHighlightColor" @change="val => {state.currentFrameToolOption.lineHighlightColor = val}" :default-value="state.currentFrameToolOption.lineHighlightColor"  class="my-picker" />
          </q-btn-dropdown>
        </div>
      </q-item>
      <div style="height:10px;" />
      <q-item-label header>문자영역 선 두께</q-item-label>
      <q-item class="row" dense>
        <div class="row" style="align-items:center;flex:0 0 50px;">
          <span>{{ parseInt(state.currentFrameToolOption.lineWidth) }}</span>
        </div>
        <div class="row col" style="align-items:center;justify-content:flex-end">
          <q-slider color="teal" v-model="state.currentFrameToolOption.lineWidth" label :min="1" :max="5" :step="1" />
        </div>
      </q-item>
    </q-card>
  </q-dialog>

  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Paddle OCR을 테스트 할 수 있는 Page입니다.
        <a href="https://github.com/PaddlePaddle/PaddleOCR">https://github.com/PaddlePaddle/PaddleOCR</a>
        <br />
        PaddleOCR - Python API를 사용하며 파라미터 변경 없이 예제 그대로 실행 합니다.
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>ocr = PaddleOCR(use_angle_cls=True, lang='ch', show_log = False)</i>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;<i>result = ocr.ocr(img_path, cls=True)</i>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;Version Information</div>
        <ul style="margin:3px">
          <li><b>PaddlePaddle:</b> 2.3.2</li>
          <li><b>PaddleOCR:</b> 2.6.1.0</li>
          <li><b>English text detection:</b> /home/jijo/.paddleocr/whl/det/en/en_PP-OCRv3_det_infer</li>
          <li><b>English text recognition:</b> /home/jijo/.paddleocr/whl/rec/en/en_PP-OCRv3_rec_infer</li>
          <li><b>Chinese text detection:</b> /home/jijo/.paddleocr/whl/det/ch/ch_PP-OCRv3_det_infer</li>
          <li><b>Chinese text recognition:</b> /home/jijo/.paddleocr/whl/rec/ch/ch_PP-OCRv3_rec_infer</li>
          <li><b>Japanese text detection:</b> /home/jijo/.paddleocr/whl/det/ml/Multilingual_PP-OCRv3_det_infer</li>
          <li><b>Japanese text recognition:</b> /home/jijo/.paddleocr/whl/rec/japan/japan_PP-OCRv3_rec_infer</li>
          <li><b>Korean text detection:</b> /home/jijo/.paddleocr/whl/det/ml/Multilingual_PP-OCRv3_det_infer</li>
          <li><b>Korean text recognition:</b> /home/jijo/.paddleocr/whl/rec/korean/korean_PP-OCRv3_rec_infer</li>
        </ul>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 관리 담당</div>
        Johan
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div style="font-size:16px;">&#8226;&nbsp;&nbsp;인식 API 주소</div>
        {{getAddress()}}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>

  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{ state.loadingLayer.message }}
  </q-inner-loading>

  <q-inner-loading :showing="compositionDropData.counterDrag > 0">
    <div class="text-h3">드롭하세요.</div>
  </q-inner-loading>

  <image-processing-dialog ref="image-processing-dialog"
    @done="listen__ip_dialog__done"
  />
</div>
</template>

<script>
import compositionDrop from '@/composition/drop.js'
import compositionFile from '@/composition/file.js'

import MixinLayer from '@/mixins/layer.js'

import ImageProcessingDialog from '@/components/ImageProcessingDialog.vue'
import SampleImageList from '@/components/SampleImageList2.vue'
import ImageView from '@/projects/ocr/views/ImageView.vue'
import BadgeText from '@/projects/ocr/components/BadgeText.vue'
import HealthCheckWidget from '@/components/healthCheckWidget.vue'

import Velocity from 'velocity-animate'

import PARSE from '@/js/parse.js'
import MISC from '@/js/miscellaneous.js'
import recognize from '@/js/recognize.js'

import {getCurrentInstance} from '@vue/composition-api'

export default {
  setup () {
    const vm = getCurrentInstance()
    if (null == vm ) {
      return {}
    }
    const {compositionFileData, preprocessingImageFile} = compositionFile(vm)
    function preprocessingFile(data) {
      const file = data instanceof File ? data : data.file
      return preprocessingImageFile(file, vm.proxy.listen__x__onfilechange, vm.proxy.listen__x__onfileerror)
    }
    const {compositionDropData, listen__x__ondragenter, listen__x__ondragleave, listen__x__ondragover, listen__x__ondrop} = compositionDrop(preprocessingFile)
    return {
      compositionDropData,
      listen__x__ondragenter,
      listen__x__ondragleave,
      listen__x__ondragover,
      listen__x__ondrop,
      compositionDrop,
      compositionFileData,
      preprocessingFile
    }
  },
  mixins: [MixinLayer],
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogOptions: {
          show: false
        },
        fitToWindow: false,
        searchText: null,
        tab: 'text',
        currentFrameState: {
          coord: {
            x: 0,
            y: 0
          },
          zoom: undefined,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        },
        currentFrameToolOption: { mouseButtonMask: 2, lineWidth: 2, lineColor: '#ffff00', lineHighlightColor: '#ff0000'},
        language: 'English'
      },
      frameData1: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      frameData2: {
        _uid: MISC.getUuid4(),
        _empty: true
      },
      pred: [],
      jsonData: [],
      predJpegImage: null,
      title: "Paddle OCR"
    }
  },
  components: {
    ImageProcessingDialog,
    SampleImageList,
    ImageView,
    BadgeText,
    HealthCheckWidget
  },
  methods: {
    listen__badge__ontoggle: function (e) {
      for (let item of this.searchTexts) {
        if (item.id == e.id) {
          item.highlight = !item.highlight;
          // this.$store.commit('frameDataPred', {id: item.id, key: 'highlight', value: item.highlight});
        }
      }
      this.updateTagging()
    },
    listen__x__onfilechange: function (file, options) {
      this.recognitionOcr(file, options)
    },
    listen__x__onfileerror: function (param) {
      const Vue = this

      Vue.jsonData = []
      Vue.compositionFileData.files = []
      Vue.clearData()
      Vue.hidingLayer()

      let color = param.color
      if (color == undefined)
        color = 'black'

      Vue.$q.notify({
        message: param.message,
        icon: 'announcement',
        color
      })
    },
    listen__image_view__onstatechange: function (data) {
      if (data.coord != undefined)
        this.state.currentFrameState.coord = {x: data.coord.x, y: data.coord.y}
      if (data.zoom != undefined)
        this.state.currentFrameState.zoom = data.zoom
      if (data.voi != undefined)
        this.state.currentFrameState.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
      const imageView2 = this.$refs['image-view2']
      if (imageView2 != undefined) {
        imageView2.tostatechange(data)
      }
    },
    listen__result__download: function () {
      const Vue = this
      try {
        const name = Vue.state.files[0].name
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(Vue.jsonData))
        var downloadAnchorNode = document.createElement('a')
        downloadAnchorNode.setAttribute("href", dataStr)
        downloadAnchorNode.setAttribute("download", name + "__.json")
        document.body.appendChild(downloadAnchorNode)
        downloadAnchorNode.click()
        downloadAnchorNode.remove()

        var link = document.createElement('a');
        link.download = name + "__.jpg";
        link.href = URL.createObjectURL(
          new Blob([Vue.predJpegImage], { type: 'image/jpeg' })
        );
        link.click();
      } catch (err) {
        Vue.$q.notify({
          message: err.message,
          icon: 'announcement',
          color: 'red'
        })
      }
    },
    listen__ip_dialog__done: async function (data) {
      const Vue = this
      if (Vue.frameData1.id != data.id) {
        Vue.listen__x__onfilechange(
          PARSE.encodeImage(Vue.frameData1.name, data.cornerstoneImage.getPixelData(), data.cornerstoneImage.width, data.cornerstoneImage.height),
          {keepFrameData0: true}
        )
      }
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          { opacity: 1 },
          { complete: done }
        )
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          { opacity: 0 },
          { complete: done }
        )
      }, delay)
    },
    clearData: function (keepFrameData0) {
      if (keepFrameData0 == false) {
        this.frameData0 = {
          _uid: MISC.getUuid4(),
          _empty: true
        }
      }
      this.frameData1 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }
      this.frameData2 = {
        _uid: MISC.getUuid4(),
        _empty: true
      }

      this.pred = []
      this.predJpegImage = null
    },
    updateTagging() {
      this.$refs['image-view1'].updateTagging()
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].updateTagging()
    },
    recognitionOcr(file, options) {
      const Vue = this
      
      const keepFrameData0 = (options != undefined && options.keepFrameData0 == true) ? true : false
      Vue.clearData(keepFrameData0)
      Vue.showLayer('이미지를 읽는 중...');
      
      MISC.doubleRaf(async () => {
        let image;
        
        let tokens = file.name.split('.');
        let ext = tokens[tokens.length - 1].toLowerCase();
        try {
          image = await PARSE.parseImage(file, ext);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'purple', message: '이미지 읽기에 실패하였습니다'})
          return
        }
        let cornerstoneImage = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, image.pixelData, image.width, image.height);

        Vue.showLayer('인식 중...');
        let ret = {};
        try {
          ret = await recognize.recognizePaddle(file, Vue.state.language);
        } catch (err) {
          console.log(err)
          Vue.listen__x__onfileerror({color: 'red', message: err})
          return
        }
        if (keepFrameData0 == true) {
          Vue.frameData1 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
        } else {
          Vue.frameData0 = {
            id: MISC.getUuid4(),
            name: file.name,
            cornerstoneImage,
            _empty: false
          }
          Vue.frameData1 = Vue.frameData0
        }
        let cornerstoneImage2 = await Vue.$cornerstone.createCornerstoneImageRgba(undefined, ret.image.pixelData, ret.image.width, ret.image.height);
        Vue.frameData2 = {
          id: MISC.getUuid4(),
          name: file.name,
          cornerstoneImage: cornerstoneImage2,
          _empty: false
        };
        Vue.pred = ret.pred
        Vue.jsonData = ret.data;
        Vue.predJpegImage = ret.image_jpeg
        Vue.hidingLayer()
      });
    },
    healthCheckFunction: recognize.recognizePaddle,
    getAddress: function () {
      const Vue = this
      return Vue.$refs['health-check'] == undefined ? '' : Vue.$refs['health-check'].getAddress()
    }
  },
  computed: {
    texts: function () {
      return this.pred
    },
    searchTexts: function () {
      if (this.texts.length == 0)
        return [];
      if (this.state.searchText == null || this.state.searchText.length == 0) {
        return this.texts.slice();
      } else {
        let searchTexts = [];
        for (let item of this.texts) {
          if (item.text.indexOf(this.state.searchText) != -1)
            searchTexts.push(item);
        }
        return searchTexts;
      }
    },
    sampleImages: function () {
      const Vue = this
      if (Vue.state.language == 'English') {
        return [
          {
            name: 'English1',
            url: `${process.env.VUE_APP_URL}/api/image/01fcbb53-aea5-4675-a0b3-46a6c9967456.jpg`
          },
          {
            name: 'English2',
            url: `${process.env.VUE_APP_URL}/api/image/23b01d6e-b444-4f3f-ae46-0f498fc83679.jpg`
          },
          {
            name: 'English3',
            url: `${process.env.VUE_APP_URL}/api/image/2612af0a-cef0-4eb0-b91e-d533ca1e85b5.jpg`
          },
          {
            name: 'English4',
            url: `${process.env.VUE_APP_URL}/api/image/5c57f351-9171-4844-8236-33da97da384c.jpg`
          },
          {
            name: 'English5',
            url: `${process.env.VUE_APP_URL}/api/image/6a398240-a257-4b43-b98d-88a0ede062e4.jpg`
          },
          {
            name: 'English6',
            url: `${process.env.VUE_APP_URL}/api/image/7edfa674-94c3-4a20-8b7d-ccac3b728525.jpg`
          }
        ]
      } else if (Vue.state.language == 'Chinese') {
        return [
          {
            name: 'Chinese1',
            url: `${process.env.VUE_APP_URL}/api/image/1458a3f8-239b-4c46-9964-95d7f9f76b6b.jpg`
          },
          {
            name: 'Chinese2',
            url: `${process.env.VUE_APP_URL}/api/image/1c501c30-c977-4946-9e70-60c0360b1e47.jpg`
          },
          {
            name: 'Chinese3',
            url: `${process.env.VUE_APP_URL}/api/image/249c5a95-9ded-477a-b472-11a8cc7c8671.jpg`
          },
          {
            name: 'Chinese4',
            url: `${process.env.VUE_APP_URL}/api/image/40dc868b-8de2-471c-a6ea-eceb6f293cfe.jpg`
          },
          {
            name: 'Chinese5',
            url: `${process.env.VUE_APP_URL}/api/image/55cf95c5-3020-4cbd-b94e-9d12cb49b3c7.jpg`
          },
          {
            name: 'Chinese6',
            url: `${process.env.VUE_APP_URL}/api/image/5a57fd00-234b-4ee9-a51e-9880b65ace1f.jpg`
          },
          {
            name: 'Chinese7',
            url: `${process.env.VUE_APP_URL}/api/image/688bf44d-4644-4493-878d-49c689e8c778.jpg`
          },
          {
            name: 'Chinese8',
            url: `${process.env.VUE_APP_URL}/api/image/91062e6e-9a4d-46f8-93a8-eac2e2ddf428.jpg`
          },
          {
            name: 'Chinese9',
            url: `${process.env.VUE_APP_URL}/api/image/91db6e69-6826-4167-8982-4e78581129cb.jpg`
          },
          {
            name: 'Chinese10',
            url: `${process.env.VUE_APP_URL}/api/image/ada17378-0434-4df3-a5c8-f6d7d3873571.jpg`
          },
          {
            name: 'Chinese11',
            url: `${process.env.VUE_APP_URL}/api/image/c0912b4b-2477-4090-97f2-0ed824ea2b23.jpg`
          },
          {
            name: 'Chinese12',
            url: `${process.env.VUE_APP_URL}/api/image/d730c4e2-d474-441d-ad5b-b944251ac58e.jpg`
          },
          {
            name: 'Chinese13',
            url: `${process.env.VUE_APP_URL}/api/image/fc7141f8-0d1c-4bc4-b6d4-589758cc8eeb.jpg`
          }
        ]
      } else if (Vue.state.language == 'Japanese') {
        return [
          {
            name: 'Japanese1',
            url: `${process.env.VUE_APP_URL}/api/image/04ca9f1d-5961-462b-819d-c579a910838c.jpg`
          },
          {
            name: 'Japanese2',
            url: `${process.env.VUE_APP_URL}/api/image/3f938465-1e0d-46f9-9566-b0f0f59beeb3.jpg`
          }
        ]
      } else if (Vue.state.language == 'Korean') {
        return [
          {
            name: 'Korean1',
            url: `${process.env.VUE_APP_URL}/api/image/7e896a5a-fa7e-407e-ac77-831708ced352.jpg`
          }
        ]
      } else
        return []
    }
  },
  watch: {
    searchTexts: function () {
      for (let item of this.texts) {
        const idx = this.searchTexts.findIndex((v) => item.id == v.id);
        if (idx != -1) {
          for (let row of this.pred) {
            if (row.id == item.id) {
              row['active'] = true
              row['highlight'] = this.searchTexts[idx].highlight
            }
          }
        } else {
          for (let row of this.pred) {
            if (row.id == item.id) {
              row['active'] = false
              row['highlight'] = false
            }
          }
        }
      }
      this.updateTagging()
    },
    'state.currentFrameToolOption.lineColor': function (value) {
      this.$refs['image-view1'].setToolOption('lineColor', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineColor', value)
    },
    'state.currentFrameToolOption.lineHighlightColor': function (value) {
      this.$refs['image-view1'].setToolOption('lineHighlightColor', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineHighlightColor', value)
    },
    'state.currentFrameToolOption.lineWidth': function (value) {
      this.$refs['image-view1'].setToolOption('lineWidth', value)
      if (this.$refs['image-view2'] != undefined)
        this.$refs['image-view2'].setToolOption('lineWidth', value)
    }
  },
  async mounted () {
    const Vue = this
    Vue.$refs['health-check'].listen__healthcheck__onclick()
  }
}
</script>

<style scoped>
@media (max-width: 1100px) {
  .image-tool-btn-group {
    display: none !important;
  }
}
</style>